// play YT video on click on thumbnail
const ptVideos = document.querySelectorAll('.p-video');
const thumbnailHidden = 'p-video__thumbnail--hide';

const toggleVideoPlay = () => {
  ptVideos.forEach((video) => {
    const playButton = video.querySelector('.pvd-playbtn');

    if (playButton) {
      playButton.addEventListener('click', ({ currentTarget }) => {
        // hide thumb
        currentTarget.parentNode.classList.toggle(thumbnailHidden);

        // start playing video
        const iframe = video.querySelector('.embed-responsive-item');
        if (!iframe) {
          return;
        }

        if (iframe.src.includes('youtube')) {
          iframe.src += '&autoplay=1';
        } else if (iframe.src.includes('vimeo')) {
          iframe.setAttribute('allow', 'autoplay');
          iframe.src += '?autoplay=1';
        }
      });
    }
  });
};

(() => {
  if (ptVideos.length) {
    toggleVideoPlay();
  }
})();
